/**
 * This modal appears when an entry is cloned from a template. It displays fields for selecting the template
 * to clone from, entering the name of the entry, the folder the entry will be created in, and a schema
 * and schema field values for the entry.
 */

import React from 'react';

import {CreateEntryFromTemplateModalContentsV2} from 'notebook/entry-templates/CreateEntryFromTemplateModal/CreateEntryFromTemplateModalContentsV2';

import {CreateEntryFromTemplateModalContentsProps} from './utils';

function CreateEntryFromTemplateModalContents(props: CreateEntryFromTemplateModalContentsProps): JSX.Element {
  return <CreateEntryFromTemplateModalContentsV2 {...props} />;
}

export default CreateEntryFromTemplateModalContents;
